"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Put HSL into a string
 */
function hslStringfy(hsl) {
    return "hsl(" + hsl[0] + ", " + hsl[1] + "%, " + hsl[2] + "%)";
}
exports.default = hslStringfy;
//# sourceMappingURL=hslStringfy.js.map